"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperAppFactoryMock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
        ],
        name: "registerAppWithHost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5061012c806100206000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063ad88671d14602d575b600080fd5b603c603836600460ba565b603e565b005b6040516379b9982960e11b81526001600160a01b0383811660048301526024820183905284169063f373305290604401600060405180830381600087803b158015608757600080fd5b505af1158015609a573d6000803e3d6000fd5b50505050505050565b6001600160a01b038116811460b757600080fd5b50565b60008060006060848603121560ce57600080fd5b833560d78160a3565b9250602084013560e58160a3565b92959294505050604091909101359056fea2646970667358221220834035565ecf6f708d3295252f03e62da71c7edc6ef972c0fd932664ec66b6e664736f6c63430008100033";
const isSuperArgs = (xs) => xs.length > 1;
class SuperAppFactoryMock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SuperAppFactoryMock__factory = SuperAppFactoryMock__factory;
SuperAppFactoryMock__factory.bytecode = _bytecode;
SuperAppFactoryMock__factory.abi = _abi;
//# sourceMappingURL=SuperAppFactoryMock__factory.js.map